"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { Zap, ChartBar, Shield } from "lucide-react";
export default function Hero() {
  const {
    ref: containerRef,
    isVisible: containerVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: cardsRef,
    isVisible: cardsVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const features = [];
  return <section data-section-id="234755" id="kayseridişklinikleri" className="relative bg-background ![padding:50px_0px_0px_0px]">
      {}
      <div className="absolute inset-0 opacity-5 bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22100%22 height=%22100%22><filter id=%22noise%22><feTurbulence type=%22fractalNoise%22 baseFrequency=%220.9%22 numOctaves=%224%22 result=%22noise%22/></filter><rect width=%22100%22 height=%22100%22 filter=%22url(%23noise)%22 opacity=%220.5%22/></svg>')] !h-[18px]" />

      <div className="relative z-10 max-w-6xl mx-auto px-4 md:px-12">
  {/* Üst Kısım: Margin-left sorunu burada düzeltildi */}
  <div ref={containerRef} className="text-center transition-all duration-1000 opacity-100 translate-y-0 mb-16 md:mb-32 md:ml-[100px]">
    {/* Alt Başlık */}
    <div className="mb-6 md:mb-8">
      <p className="text-sm md:text-base tracking-wide" style={{
            color: "#baa05e"
          }}>
        Sağlıklı Gülüşler, Güvenli Dokunuşlar
      </p>
    </div>

    {/* Başlıklar */}
    <h1 className="font-default mb-6 md:mb-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-tight">
      <span className="text-foreground">Kayseri Diş Klinikleri</span>
    </h1>

    <h2 className="font-default mb-4 md:mb-4 text-2xl md:text-3xl lg:text-4xl font-semibold leading-tight">
      <span style={{
            color: "#baa05e"
          }}>Kayseri Diş Poliklinikleri</span>
    </h2>

    <h2 className="font-default mb-6 md:mb-8 text-2xl md:text-3xl lg:text-4xl font-semibold leading-tight">
      <span style={{
            color: "#baa05e"
          }}>Kayseri İmplant</span>
    </h2>

    {/* Açıklama Metni */}
    <p className="mb-8 md:mb-12 text-base md:text-lg font-default text-muted-foreground max-w-2xl mx-auto leading-relaxed">
      Modern teknoloji ve estetik dokunuşların buluştuğu kliniğimizde, size özel tedavi planları ile sağlıklı ve özgüvenli gülüşler tasarlıyoruz.
    </p>

    {/* Butonlar */}
    <div className="flex flex-col sm:flex-row gap-4 md:gap-6 justify-center mb-8 md:mb-12">
      <Link to="tel:+905535523234">
        <Button variant="default" size="lg" className="w-full sm:w-auto text-white shadow-lg rounded-full px-8" style={{
              backgroundColor: "#baa05e"
            }}>
          Hemen Arayın
        </Button>
      </Link>

      <Link to="/TreatmentsPage">
        <Button variant="outline" size="lg" className="w-full sm:w-auto rounded-full px-8 border-2" style={{
              borderColor: "#baa05e",
              color: "#baa05e"
            }}>
          Tedavilerimiz
        </Button>
      </Link>
    </div>
  </div>

  {/* Kartlar Bölümü */}
  <div ref={cardsRef} className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8 lg:gap-10 transition-all duration-1000 ${cardsVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
    {features.map((feature, i) => <div key={feature.id} data-index={i} className="relative p-6 md:p-8 border border-border bg-card group hover:border-primary/50 transition-colors duration-300 shadow-sm rounded-lg">
        {/* Köşe Süslemeleri */}
        <div className="absolute top-0 left-0 w-4 h-4 border-t border-l border-primary/30 group-hover:border-primary transition-colors duration-300" />
        <div className="absolute top-0 right-0 w-4 h-4 border-t border-r border-primary/30 group-hover:border-primary transition-colors duration-300" />
        <div className="absolute bottom-0 left-0 w-4 h-4 border-b border-l border-primary/30 group-hover:border-primary transition-colors duration-300" />
        <div className="absolute bottom-0 right-0 w-4 h-4 border-b border-r border-primary/30 group-hover:border-primary transition-colors duration-300" />

        <div className="relative z-10">
          <div className="mb-6 text-5xl md:text-6xl font-default font-bold text-primary/20 group-hover:text-primary/40 transition-colors">
            {feature.number}
          </div>
          <h3 className="font-default mb-4 text-xl md:text-2xl font-semibold text-foreground">
            {feature.title}
          </h3>
          <p className="font-default text-sm md:text-base text-muted-foreground leading-relaxed">
            {feature.description}
          </p>
        </div>
      </div>)}
  </div>
</div>
    </section>;
}